import { canReadFinancialKind } from '../../core/finance/financialBoundary';

// Display readiness only; Firestore remains the authorization boundary.
export async function financialViewAvailable(access, tenantId, readReadiness) {
  if (!tenantId || tenantId === 'all' || access?.active !== true || access.disabled === true || access?.tenantId !== tenantId ||
      !['shifts', 'facilityProfiles'].some(kind => canReadFinancialKind(access, kind))) {
    return false;
  }
  try {
    return (await readReadiness(tenantId))?.ready === true;
  } catch {
    return false;
  }
}
